import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

type Props = {
    data: DescriptionWithRichTextAndImage
};

const Text: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();
    const colourTheme = JSON.parse(data.theme);
    const { textColour } = colourTheme;

    const textStyle = css`
        width: 97%;
        align-self: flex-start;
        font-weight: ${theme.fonts.weights.light};

        ${(data.textColour || textColour) && css`
            color: ${data.textColour || textColour};
        `}
        
        ${theme.breakpoints.only("md")} {
            margin-bottom: 55px;
        }

        ${theme.breakpoints.down("sm")} {
            margin-bottom: 12px;
        }
    `;

    return (
        <ContentCombine Tag={"p"} fontSizeType={"9"} css={textStyle}>{data.text}</ContentCombine>
    );
};

export default Text;
